import React, { useState } from 'react';
import { Container, Row, Col, Card, Nav, Alert } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';

// Tabs (los iremos creando en fases siguientes)
import FirmasExternasTab from '../components/apis/FirmasExternasTab';
import MultimediaHcTab from '../components/apis/MultimediaHcTab';
import FarmaciaTab from '../components/apis/FarmaciaTab';

const ApisExternasPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('firmas');
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);

  const mostrarExito = (mensaje) => {
    setSuccessMessage(mensaje);
    setTimeout(() => setSuccessMessage(null), 3000);
  };

  const mainContentStyle = {
    marginLeft: sidebarOpen ? '250px' : '70px',
    transition: 'margin-left 0.3s ease-in-out',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px'
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar onToggle={setSidebarOpen} />

      <div style={mainContentStyle}>
        <Container fluid>
          {/* Header */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h2 className="mb-1">
                    <i className="bi bi-plug-fill text-primary me-2"></i>
                    APIs Externas
                  </h2>
                  <p className="text-muted mb-0">
                    Integraciones disponibles para sistemas externos de la organización
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Mensaje de éxito */}
          {successMessage && (
            <Alert variant="success" dismissible onClose={() => setSuccessMessage(null)}>
              <i className="bi bi-check-circle me-2"></i>
              {successMessage}
            </Alert>
          )}

          {/* Mensaje de error */}
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              <i className="bi bi-exclamation-triangle me-2"></i>
              {error}
            </Alert>
          )}

          {/* Contenido Principal con Tabs */}
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white">
              <Nav variant="tabs" activeKey={activeTab} onSelect={setActiveTab}>
                <Nav.Item>
                  <Nav.Link eventKey="firmas">
                    <i className="bi bi-pen me-2"></i>
                    Firmas Externas
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="multimedia">
                    <i className="bi bi-collection-play me-2"></i>
                    Multimedia HC
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="farmacia">
                    <i className="bi bi-capsule me-2"></i>
                    Farmacia
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
            <Card.Body style={{ minHeight: '400px' }}>
              {activeTab === 'firmas' && (
                <FirmasExternasTab onSuccess={mostrarExito} onError={setError} />
              )}
              {activeTab === 'multimedia' && (
                <MultimediaHcTab onSuccess={mostrarExito} onError={setError} />
              )}
              {activeTab === 'farmacia' && (
                <FarmaciaTab onSuccess={mostrarExito} onError={setError} />
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
};

export default ApisExternasPage;